import { Logger } from '@sitecore-search/common';
import { buildRequestObject, facetSchemaFormatter, validateFilters } from './eventUtils.js';
import { trackSearchClickEntityEvent, trackSearchClickFacetEvent } from './widgetEvents.js';
/**
 * @desc Sent when users clicks Search Results Widget entity
 * @param rfkId
 * @param entity
 * @param object: manage extra event fields
 * @returns {Promise<*>}
 */
export const trackSearchResultsClickEntityEvent = async (rfkId, entity, { index, items, ...request }) => {
    if (!rfkId) {
        Logger.warn('trackEvent :::', `Widget's rfkId mandatory field is empty`);
        return;
    }
    return await trackSearchClickEntityEvent(rfkId, entity, {
        actionCause: 'entity',
        index,
        request: buildRequestObject(request),
        items,
    });
};
/**
 * @desc Sent when users clicks Search Results Widget facet/filter
 * @param rfkId
 * @param entity
 * @param object: manage extra event fields
 * @returns {Promise<*>}
 */
export const trackSearchResultsFacetClickEvent = async (rfkId, { index, filters, ...request }) => {
    if (!rfkId) {
        Logger.warn('trackEvent :::', `Widget's rfkId mandatory field is empty`);
        return;
    }
    if (filters && !validateFilters(filters)) {
        Logger.warn('trackEvent :::', `Filter's name is not defined`);
        return;
    }
    return await trackSearchClickFacetEvent(rfkId, {
        index,
        request: buildRequestObject(request),
        filters: facetSchemaFormatter(filters),
    });
};
